import { PMDescriptionCard } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { DashboardCardContext } from "../context";

export function addManagementSummaryCard(ctx: DashboardCardContext) {
  const { view } = ctx;

  const managementSummaryComponent = view.addComponent({
    component: PMDescriptionCard,
    layoutProps: {
      componentId: "managementSummaryComponent",
      title: "",
      description: "",
      labels: ["managementSummary"],
    },
  });

  managementSummaryComponent.mapLayoutProps(({ language }) => ({
    componentId: "managementSummaryComponent",
    labels: ["managementSummary"],
    description: getLocalizedMessage(
      language || "en",
      "cards.managementSummary.description"
    ),
    title: getLocalizedMessage(language, "cards.managementSummary.title"),
  }));

  managementSummaryComponent.mapState(({ dashboard, language }) => {
    return {
      title: getLocalizedMessage(language, "managementSummary"),
      description: dashboard?.managementSummary || "",
      text: dashboard?.managementSummary || "",
    };
  });
}
